import axios from './http';
import global from '@/constants/Global.constants'

export default {
  getOrderNo (params) {//获取订单号
    return axios.post(global.DMZ_BASE +'/common/getOrderNo', params);
  },
  cancelOrder (params) {//取消订单
    return axios.post(global.IMS_ORDER + '/sales/cancelOrder', params);
  },
  deleteOrder (params) {//删除订单
    return axios.post(global.IMS_ORDER + '/sales/deleteOrder', params);
  },
  orderDetail (params) {//订单详情
    return axios.post(global.IMS_ORDER + '/sales/findOrderDetails', params);
  },
  insertOrder (params) {//新增订单
    return axios.post(global.IMS_ORDER + '/sales/insertOrder', params);
  },
  updateOrderDetail (params) {//修改订单详情
    return axios.post(global.IMS_ORDER + '/sales/findWhenUpdateOrder', params);
  },
  updateOrder (params) {//修改订单
    return axios.post(global.IMS_ORDER + '/sales/updateOrder', params);
  },
  orderVerify (params) {//订单审核
    return axios.post(global.IMS_ORDER + '/sales/verify', params);
  },
  orderDeliverDetail (params) {//订单发货页面查询
    return axios.post(global.IMS_ORDER +'/sales/deliver', params);
  },
  gatheringDetail (params) {//订单收款页面查询
    return axios.post(global.IMS_ORDER + '/sales/findWhenGathering', params);
  },
  addGathering (params) {//订单新增收款
    return axios.post(global.IMS_ORDER + '/sales/insertGathering', params);
  },
  deliverCheck (params) {//检查是否可以发货
    return axios.post(global.IMS_ORDER + '/sales/checkDeliver', params);
  },
  insertDeliver (params) {//新增发货单
    return axios.post(global.IMS_ORDER + '/deliver/insertDeliver', params);
  },
  deliverDetail (params) {//发货单详情
    return axios.post(global.IMS_ORDER + '/deliver/findDeliverDetails', params);
  },
  deliverVerify (params) {//发货单审核
    return axios.post(global.IMS_ORDER + '/deliver/verify', params);
  }
}



// WEBPACK FOOTER //
// ./src/request/order.js